module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGa1c63be730897713032983e7287004e9.a1c63be7.png";